import { render, staticRenderFns } from "./draft-list.vue?vue&type=template&id=1175f2de"
import script from "./draft-list.vue?vue&type=script&lang=js"
export * from "./draft-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1175f2de')) {
      api.createRecord('1175f2de', component.options)
    } else {
      api.reload('1175f2de', component.options)
    }
    module.hot.accept("./draft-list.vue?vue&type=template&id=1175f2de", function () {
      api.rerender('1175f2de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/common-physical-model/draft-list.vue"
export default component.exports